import { validateGeolocation } from 'js/hooks/auth/pas';
import { MutableRefObject, useCallback } from 'react';

import * as constants from '../constants';
import * as Types from '../types';

export const useTriggerGeolocation = ({
    setTransactionID,
    setLicense,
    setNextTime,
    setShowOverlay,
    cancelRef,
    geolocationType,
    reasonRef
}: {
    setTransactionID: (transactionID: string | null) => void;
    setLicense: (license: string | null) => void;
    setNextTime: (nextTime: number) => void;
    setShowOverlay: (showOverlay: boolean) => void;
    cancelRef: MutableRefObject<any>;
    reasonRef: MutableRefObject<constants.GEOLOCATION_REASON>;
    geolocationType: string;
}) => {
    return useCallback(async ({
        latitude = null,
        longitude = null,
        reason = null
    }: Types.ITriggerGeolocationOptions = {}) => {
        if (cancelRef.current) {
            return;
        }

        // set the reason for Geolocation
        reasonRef.current = reason ?? constants.GEOLOCATION_REASON.UNDEFINED;

        setTransactionID(null);
        setLicense(null);
        setNextTime(0);

        const response = await validateGeolocation(latitude, longitude, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};

        if (!sessionValidationData.SessionValidationByGeolocationData) {
            // no geofencing -- go straight to end.
            return;
        }

        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const nextCheckIn = Number(geolocationData.nextCheckIn);

        if (nextCheckIn > 0) {
            // check will be done in some time, all good for now
            setShowOverlay(false);
        } else {
            setShowOverlay(true);
        }

        // ensure that nextTime is set before setting license and txId
        setNextTime(nextCheckIn);

        setTransactionID(geolocationData.transactionId);
        setLicense(geolocationData.license || geolocationData.properties);
    }, [setShowOverlay, setTransactionID, setLicense, setNextTime, cancelRef, geolocationType, reasonRef]);
};
